import React from "react";
import "./schoolAdmin.css";

class schoolAdminCoachDetails extends React.Component {
  render() {
    return <h1>Working !!</h1>;
  }
}
export default schoolAdminCoachDetails;
